import { Form, message } from 'antd'
import { Props } from '.'
import { ImportModalType } from '../../../pages/toSubmitGoods/reducer'
import {
  DOWNLOAD_EXTEND_TEMPLATE,
  DOWNLOAD_PICTURE_TEMPLATE,
  DOWN_PROJECT_TEMPLATE,
} from '../../../api/MaterialApi'
import {
  GET_DOWNLOAD_QUALIFICATION_UPDATE_PICTURE_TEMPLATE,
  POST_BATCH_UPDATE_QUALIFICATION_PICTURE,
} from '@/api/reportApi'
import { convertProjectTypeDTOList } from '../../../components/RelationProjectCheckGroup/hooks'
import { useEffect, useReducer } from 'react'
import reducer, {
  initialState,
  resetStateAction,
  setCurrentStepAction,
  setLoadingStateAction,
} from './reducer'
import {
  BATCH_UPDATE_EXPAND,
  BATCH_UPDATE_PICTURE,
  BATCH_UPDATE_PROJECT,
} from '../../../api/uploadfileapi'
import { UploadFileItem } from '../../../components/BatchUpload'
import { isResponseCodeSuccess } from '../../../tools/util'

export function useSetupHook(props: Props) {
  const { open, productIds } = props
  const [form] = Form.useForm()
  const [relationProjectForm] = Form.useForm()
  const [state, dispatch] = useReducer(reducer, initialState)
  const { loadingState } = state
  const { onImportSuccess } = props
  const handleDownloadTemplate = async () => {
    const type = props.title as ImportModalType
    switch (type) {
      case '导入上架项目':
        const relationProjectFormValues =
          await relationProjectForm.getFieldsValue()
        if (
          relationProjectFormValues.relationProject === undefined ||
          relationProjectFormValues.relationProject?.length < 1
        ) {
          message.warning('请先选中关联项目')
          return
        }
        DOWN_PROJECT_TEMPLATE({
          productIds: productIds,
          projects: convertProjectTypeDTOList(
            relationProjectFormValues.relationProject,
          ),
        })
        break
      case '导入图片':
        DOWNLOAD_PICTURE_TEMPLATE({
          productIds,
        })
        break
      case '导入拓展属性':
        DOWNLOAD_EXTEND_TEMPLATE({
          productIds,
        })
        break
      case '导入资质图片':
        GET_DOWNLOAD_QUALIFICATION_UPDATE_PICTURE_TEMPLATE({
          productIds,
        })
        break
    }
  }
  const handleStepChange = (current: number) => {
    dispatch(setCurrentStepAction(current))
  }
  function resetModalState() {
    dispatch(setCurrentStepAction(0))
    dispatch(resetStateAction())
    relationProjectForm.resetFields()
  }
  async function handleImportClick() {
    const type = props.title
    const relationProjectFormValues = relationProjectForm.getFieldsValue()
    const uploadFile: UploadFileItem = relationProjectFormValues.file
    dispatch(
      setLoadingStateAction({
        ...loadingState,
        isImportLoading: true,
      }),
    )
    switch (type) {
      case '导入上架项目':
        {
          const res = await BATCH_UPDATE_PROJECT(uploadFile?.originFile)
          if (isResponseCodeSuccess(res.code)) {
            message.success('导入任务已移交至任务中心，请稍后')
            onImportSuccess?.()
          }
        }
        break
      case '导入图片':
        {
          const res = await BATCH_UPDATE_PICTURE(uploadFile?.originFile)
          if (isResponseCodeSuccess(res.code)) {
            message.success('导入任务已移交至任务中心，请稍后')
            onImportSuccess?.()
          }
        }
        break
      case '导入拓展属性':
        {
          const res = await BATCH_UPDATE_EXPAND(uploadFile?.originFile)
          if (isResponseCodeSuccess(res.code)) {
            message.success('导入任务已移交至任务中心，请稍后')
            onImportSuccess?.()
          }
        }
        break
      case '导入资质图片':
        {
          const res = await POST_BATCH_UPDATE_QUALIFICATION_PICTURE(
            uploadFile?.originFile,
          )
          if (isResponseCodeSuccess(res.code)) {
            message.success('导入任务已移交至任务中心，请稍后')
            onImportSuccess?.()
          }
        }
        break
    }
    dispatch(
      setLoadingStateAction({
        ...loadingState,
        isImportLoading: false,
      }),
    )
  }
  useEffect(() => {
    if (open) {
      resetModalState()
    }
    // eslint-disable-next-line
  }, [open])

  return {
    form,
    relationProjectForm,
    handleDownloadTemplate,
    handleStepChange,
    handleImportClick,
    state,
  }
}
import { Form, message } from 'antd'
import { Props } from '.'
import { ImportModalType } from '../../../pages/toSubmitGoods/reducer'
import {
  DOWNLOAD_EXTEND_TEMPLATE,
  DOWNLOAD_PICTURE_TEMPLATE,
  DOWN_PROJECT_TEMPLATE,
} from '../../../api/MaterialApi'
import {
  GET_DOWNLOAD_QUALIFICATION_UPDATE_PICTURE_TEMPLATE,
  POST_BATCH_UPDATE_QUALIFICATION_PICTURE,
} from '@/api/reportApi'
import { convertProjectTypeDTOList } from '../../../components/RelationProjectCheckGroup/hooks'
import { useEffect, useReducer } from 'react'
import reducer, {
  initialState,
  resetStateAction,
  setCurrentStepAction,
  setLoadingStateAction,
} from './reducer'
import {
  BATCH_UPDATE_EXPAND,
  BATCH_UPDATE_PICTURE,
  BATCH_UPDATE_PROJECT,
} from '../../../api/uploadfileapi'
import { UploadFileItem } from '../../../components/BatchUpload'
import { isResponseCodeSuccess } from '../../../tools/util'

export function useSetupHook(props: Props) {
  const { open, productIds } = props
  const [form] = Form.useForm()
  const [relationProjectForm] = Form.useForm()
  const [state, dispatch] = useReducer(reducer, initialState)
  const { loadingState } = state
  const { onImportSuccess } = props
  const handleDownloadTemplate = async () => {
    const type = props.title as ImportModalType
    switch (type) {
      case '导入上架项目':
        const relationProjectFormValues =
          await relationProjectForm.getFieldsValue()
        if (
          relationProjectFormValues.relationProject === undefined ||
          relationProjectFormValues.relationProject?.length < 1
        ) {
          message.warning('请先选中关联项目')
          return
        }
        DOWN_PROJECT_TEMPLATE({
          productIds: productIds,
          projects: convertProjectTypeDTOList(
            relationProjectFormValues.relationProject,
          ),
        })
        break
      case '导入图片':
        DOWNLOAD_PICTURE_TEMPLATE({
          productIds,
        })
        break
      case '导入拓展属性':
        DOWNLOAD_EXTEND_TEMPLATE({
          productIds,
        })
        break
      case '导入资质图片':
        GET_DOWNLOAD_QUALIFICATION_UPDATE_PICTURE_TEMPLATE({
          productIds,
        })
        break
    }
  }
  const handleStepChange = (current: number) => {
    dispatch(setCurrentStepAction(current))
  }
  function resetModalState() {
    dispatch(setCurrentStepAction(0))
    dispatch(resetStateAction())
    relationProjectForm.resetFields()
  }
  async function handleImportClick() {
    const type = props.title
    const relationProjectFormValues = relationProjectForm.getFieldsValue()
    const uploadFile: UploadFileItem = relationProjectFormValues.file
    dispatch(
      setLoadingStateAction({
        ...loadingState,
        isImportLoading: true,
      }),
    )
    switch (type) {
      case '导入上架项目':
        {
          const res = await BATCH_UPDATE_PROJECT(uploadFile?.originFile)
          if (isResponseCodeSuccess(res.code)) {
            message.success('导入任务已移交至任务中心，请稍后')
            onImportSuccess?.()
          }
        }
        break
      case '导入图片':
        {
          const res = await BATCH_UPDATE_PICTURE(uploadFile?.originFile)
          if (isResponseCodeSuccess(res.code)) {
            message.success('导入任务已移交至任务中心，请稍后')
            onImportSuccess?.()
          }
        }
        break
      case '导入拓展属性':
        {
          const res = await BATCH_UPDATE_EXPAND(uploadFile?.originFile)
          if (isResponseCodeSuccess(res.code)) {
            message.success('导入任务已移交至任务中心，请稍后')
            onImportSuccess?.()
          }
        }
        break
      case '导入资质图片':
        {
          const res = await POST_BATCH_UPDATE_QUALIFICATION_PICTURE(
            uploadFile?.originFile,
          )
          if (isResponseCodeSuccess(res.code)) {
            message.success('导入任务已移交至任务中心，请稍后')
            onImportSuccess?.()
          }
        }
        break
    }
    dispatch(
      setLoadingStateAction({
        ...loadingState,
        isImportLoading: false,
      }),
    )
  }
  useEffect(() => {
    if (open) {
      resetModalState()
    }
    // eslint-disable-next-line
  }, [open])

  return {
    form,
    relationProjectForm,
    handleDownloadTemplate,
    handleStepChange,
    handleImportClick,
    state,
  }
}
